<template>
	<div>
		<TabGroup :default-index="defaultIndex" @change="onChangeTab">
			<TabList
				class="scrollbar-visibility-hidden relative flex overflow-x-auto md:overflow-x-auto"
				:class="[]"
			>
				<Tab
					v-for="(tab, index) in tabs"
					:key="_kebabCase(tab.label)"
					v-slot="{ selected }"
					as="template"
				>
					<div
						:class="[
							'relative cursor-pointer pb-6 outline-none duration-300',
							selected ? tabActiveLabelColor : tabLabelColor,
							index === 0
								? 'mr-6'
								: index !== tabs.length - 1
									? 'mx-6'
									: '',
							index === tabs.length - 1 ? 'ml-6' : '',
							index !== 0 && index !== tabs.length - 1
								? 'mx-6'
								: '',
						]"
					>
						<span
							class="whitespace-nowrap text-lg"
							:class="[
								selected ? 'font-medium text-blue-400' : '',
							]"
						>
							{{ tab.label }}
						</span>
						<span
							class="absolute inset-x-0 bottom-0 z-10 flex h-[3px] items-center"
						>
							<span
								class="w-full duration-300"
								:class="[
									selected
										? 'h-[3px] bg-blue-400'
										: 'h-[1px] bg-gray-200',
								]"
							></span>
						</span>
					</div>
				</Tab>
				<span
					class="absolute inset-x-0 bottom-0 z-0 flex h-[3px] items-center"
				>
					<span
						class="w-full"
						:class="['h-[1px] bg-gray-200']"
					></span>
				</span>
			</TabList>
			<TabPanels :class="[tabPanelMargin]">
				<TabPanel
					v-for="tab in tabs"
					:key="_kebabCase(tab.label)"
					:class="['outline-none', 'shadow-none']"
				>
					<slot
						:name="`${tab.slug ? tab.slug : _kebabCase(tab.label)}`"
					></slot>
				</TabPanel>
			</TabPanels>
		</TabGroup>
	</div>
</template>

<script setup>
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from '@headlessui/vue'
import { kebabCase as _kebabCase } from 'lodash-es'

const props = defineProps({
	tabs: {
		type: Array,
		required: true,
	},
	defaultIndex: {
		type: Number,
		default: 0,
		required: false,
	},
	tabPanelMargin: {
		type: String,
		default: 'mt-6',
		required: false,
	},
	tabLabelColor: {
		type: String,
		default: 'text-gray-700',
		required: false,
	},
	tabActiveLabelColor: {
		type: String,
		default: 'text-gray-700',
		required: false,
	},
	textColor: {
		type: String,
		default: 'text-gray-600',
		required: false,
	},
	fontWeight: {
		type: String,
		default: '',
		required: false,
	},
	fontSize: {
		type: String,
		default: 'text-base',
		required: false,
	},
	lineHeight: {
		type: String,
		default: 'leading-normal',
		required: false,
	},
	underline: {
		type: Boolean,
		default: true,
		required: false,
	},
	underlineColor: {
		type: String,
		default: 'decoration-gray-600',
		required: false,
	},
})

const emit = defineEmits(['changeTab'])

const onChangeTab = (index) => {
	emit('changeTab', index)
}
</script>
